// extracted by mini-css-extract-plugin
module.exports =  {"other_offers":"_32bbee5fda--other_offers--_O4Nd"};